import axios, { Method } from '@/apps/open/utils/axios'

const resourceName = '/api/me'

/**
 * 获取功能邮件信息
 */
export const getFunEmailInfo = (function_id: number, developer_id: number | string) => axios({ url: `${resourceName}/dev_func_email`, method: Method.Get, params: { function_id, developer_id } })

/**
 * 更新功能邮件信息
 */
export const updateFunEmailInfo = (params: any) => axios({ url: `${resourceName}/dev_func_email`, method: Method.Put, data: params })

/**
 * 添加功能邮件信息
 */
export const addFunEmailInfo = (params: any) => axios({ url: `${resourceName}/dev_func_email`, method: Method.Post, data: params })
